module.exports = __webpack_public_path__ + "img/stu-male.cb57bad0.png";